import React from 'react';
import { Link } from 'react-router-dom';

import './BackButton.scss';
import Button from '../Button';
import Icon from '../Icon';

const BackButton = ({ to }) => (
  <Button component={Link} to={to}>
    <Icon type="back" />
    <span className="back-button__text">Anterior</span>
  </Button>
);

export default BackButton;
